import { IApplicationState } from '../../types/redux';

export function getIsSalesLeader(state: IApplicationState) {
  return state.newbuilding.isSalesLeader;
}
